import { amendPriceForCalendarCell } from './amendPriceForCalendarCell';

type RawCalendarCellPrice = number | `${number}` | null;
type Localisation = {
  formatCurrency(arg0: number): string;
  formatCurrencyShort(arg0: number): string;
};

const COMPACT_THRESHOLD = 10_000;

export const getCalendarFormattedPrice = (
  price: RawCalendarCellPrice,
  localisation: Localisation,
): string | null => {
  const priceNumber = Number(price);
  if (Number.isNaN(priceNumber) || priceNumber <= 0) return null;

  const priceFormatted =
    priceNumber >= COMPACT_THRESHOLD
      ? localisation.formatCurrencyShort(priceNumber)
      : localisation.formatCurrency(priceNumber);
  const zeroFormatted = localisation.formatCurrency(0);

  return amendPriceForCalendarCell(priceFormatted, zeroFormatted);
};
